import React from "react";
import UserAvatar from "components/userComponents/UserAvatar";
import { useRouter } from "next/router";

export default function PostDetailsBar({ post }) {
  const { user } = post;
  const router = useRouter();

  const navigateToUser = () => {
    router.push(`/user/${user.username}`);
  };
  return (
    <div className="lg:hidden absolute bottom-[15px] flex flex-col left-0 w-[325px] max-w-[325px ">
      <div className="flex flex-row w-full">
        <div className="py-4 px-2">
          <UserAvatar
            handleClick={navigateToUser}
            user={user}
            active
            size="large"
          />
        </div>
        <div
          className="flex flex-col justify-center px-0 max-w-full overflow-hidden "
          onClick={navigateToUser}
          aria-hidden="true"
        >
          <span className="text-shadow-text text-white text-lg text-ellipsis overflow-hidden whitespace-nowrap ">
            {post.user.name}
          </span>
          <span className="text-shadow-text text-white text-lg text-ellipsis overflow-hidden whitespace-nowrap ">
            @{post.user.username}
          </span>
        </div>
      </div>
      <div className="px-2 flex justify-start max-w-full text-white overflow-hidden">
        <span className="text-shadow-text text-white text-lg text-left">
          {post.title}
        </span>
      </div>
    </div>
  );
}
